import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BaseHttpClientService } from './base-http-client.service';

@Injectable()
export class AdminCacheService extends BaseHttpClientService {
  constructor(
    private http: HttpClient,
  ) {
    super()
  }

  public clearCache(): any {
    return this.http.get(environment.apiUrl + 'management/evict-cache/all', { responseType: 'text' });
  }
}
